import React, { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import { Toast, ToastContainer } from "react-bootstrap";
import { toast } from "react-toastify";
// import { getPlatformImg } from "../../../helpers/getImgSrc";
// import { getPlatformName } from "../../../helpers/getPlatformName";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
import { getGoogleAnalyticsPropertylist, getGoogleAnalyticsPropertyDetails, updateGoogleAnalyticsPropertyDetails, getGoogleAnalyticsWebsiteMetrics } from "../../../services/ApiService"
import { handleApi } from "../../../utils/authentication";

const GoogleAnalytics = () => {
  const [loading, setLoading] = useState({
    platforms: false,
    domains: false,
    links: false

  });
  const [btnLoading, setBtnLoading] = useState(false)
  // const [showToast, setShowToast] = useState(false);
  const [properties, setProperties] = useState([])
  const [selectedProperty, setSelectedProperty] = useState(null)
  const [websites, setWebsites] = useState([])
  const [links, setLinks] = useState([])
  const [linksLoading, setLinksLoading] = useState(false)
  const [linksPageData, setLinksPageData] = useState({
    total_links: 0,
    offset: 0,
    limit: 10,


  })
  const [inputSearch, setInputSearch] = useState("")
  const timeoutRef = useRef(null)
  const inputSearchRef = useRef(null)
  // const [platform,setPlatform]=useState({
  //   platform_id:5,
  //   name:"Google Analytics"
  // })

  const handleSave = () => {
    setLoading(true);
    // Simulate a save operation
    setTimeout(() => {
      setLoading(false);
      toast.success("Saved successfully");
    }, 2000);
  };


  const fetchGoogleAnalyticsPropertylist = async () => {
    try {
      setLoading((prev) => {
        return { ...prev, domains: true }
      })
      let result = await getGoogleAnalyticsPropertylist()
      if (result?.success) {
        if (result?.data?.properties?.length > 0) {
          setProperties(result?.data?.properties)
        }
      }


    } catch (e) {
      console.log(e)
    } finally {
      setLoading((prev) => {
        return { ...prev, domains: false }
      })
    }

  }
  //fetching property details
  const handlePropertySelect = async (property) => {
    try {
      setLoading((prev) => {
        return { ...prev, links: true }
      })
      setLinks([])
      setLinksPageData({
        total_links: 0,
        offset: 0,
        limit: 10,
      })
      if (property != null) {

        let urls = []
        setSelectedProperty(property)
        let result = await getGoogleAnalyticsPropertyDetails(property?.property_id)

        if (result?.success) {


          if (result?.data?.property_details?.websites?.length > 0) {
            result?.data?.property_details?.websites.forEach((element, index) => {
              let website = {
                url: element?.website_url,
                id: index,
                metrics: null,
                loading: false,
                is_mapped: true
              }
              urls.push(website)

            });

          }

        }
        // for(let i=result?.data?.property_details?.websites?.length?result?.data?.property_details?.websites?.length:0;i<10;i++)
        //   {
        //     let website={
        //       url:'',
        //       id:i
        //     }
        //     urls.push(website)

        //   }
        setWebsites(urls)
      }

    } catch (e) {
      console.log(e)
    } finally {
      setLoading((prev) => {
        return { ...prev, links: false }
      })
    }

  }

  const fetchLinksUnderProperty = async (type = "next") => {
    try {
      // no property selected
      setLinksLoading(true)
  
      if (!selectedProperty?.property_id) {
        console.error("property_id is missing");
        return;
      }

      // already at or beyond total links → stop
      if (linksPageData.total_links > 0 && linksPageData.offset >= linksPageData.total_links) {
        return;
      }

      // calculate new offset
      const newOffset = Math.max(
        0,
        Math.min(linksPageData.offset + linksPageData.limit, linksPageData.total_links)
      );
      
      const formData = new FormData();
      formData.append("property_id", selectedProperty.property_id);
      formData.append("offset", newOffset);
      formData.append("limit", linksPageData.limit);
      if (inputSearchRef.current !== "" && inputSearchRef.current !== null) {
        formData.append("search", inputSearchRef.current)
      }

      let result = await handleApi("get_list_of_endpoints_under_property", "POST", {}, formData);

      if (result?.success) {
        let updatedLinks = []
        if (result?.data?.links?.length > 0) {
          updatedLinks = result?.data?.links.map((element, index) => {
            return { url: element?.url, id: index, is_mapped: element?.is_mapped, loading: false }
          })

          setLinks((prevLinks) => {
            const map = new Map();

            if (type === "next") {
              prevLinks.forEach((link) => map.set(link.url, link));
            }

            updatedLinks.forEach((link) => map.set(link.url, link));

            return Array.from(map.values());
          });

        }

        setLinksPageData((prev) => ({
          ...prev,
          offset: parseInt(result.data?.offset),
          total_links: parseInt(result.data?.total_links),
        }));
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLinksLoading(false)
    }
  };


  const handleInputSearchChange = (search_query) => {
    setInputSearch(search_query);
    inputSearchRef.current = search_query;
    setLinksPageData({
      total_links: 0,
      offset: 0,
      limit: 10,
    })

    if (search_query === "") {

      fetchLinksUnderProperty("next");
      return;
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      fetchLinksUnderProperty("search");
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);






  const handleInputChange = (new_input, website) => {

    setWebsites((prevWebsites) =>
      prevWebsites.map((element) =>
        element.id === website.id ? { ...element, url: new_input } : element
      )
    );
  }

  const handleUpdateGoogleAnalyticsProperty = async () => {
    try {
      setBtnLoading(true)

      if (selectedProperty === null) {
        toast.error("No Property Selected")

        return
      }

      let result = await updateGoogleAnalyticsPropertyDetails(selectedProperty, websites)

      if (result?.success) {
        handlePropertySelect(selectedProperty)
        toast.success('Property details updated successfully')
      }

    }
    catch (e) {
      console.log(e)
    }
    finally {
      setBtnLoading(false)
    }

  }

  // const handleGetWebsiteMetrics=async (website)=>{
  //   try{
  //     if(website==null)
  //     {
  //       toast.error("Failed to fetch metrics")
  //       return
  //     }
  //     setWebsites((prevWebsites) =>
  //       prevWebsites.map((element) =>
  //         element.id === website.id ? { ...element, loading:true } : element
  //       )
  //     );
  //     let result=await getGoogleAnalyticsWebsiteMetrics(selectedProperty,website?.url)
  //     if(result?.success)
  //     {
  //       if(result?.data?.website_metrics?.length>0)
  //       {
  //         setWebsites((prevWebsites) =>
  //           prevWebsites.map((element) =>
  //             element.id === website.id ? { ...element, metrics:result?.data?.website_metrics } : element
  //           )
  //         );

  //       }else{
  //         toast.error("Website Metrics not available")
  //       }


  //     }else{
  //       toast.error("Website Metrics not available")
  //     }

  //   }catch(e)
  //   {
  //     console.log(e)
  //   }finally{
  //     setWebsites((prevWebsites) =>
  //       prevWebsites.map((element) =>
  //         element.id === website.id ? { ...element, loading:false } : element
  //       )
  //     );
  //   }
  // }

  const handleTrackLink = async (link) => {
    try {
      let updatedWebsites = []
      if (link?.is_mapped) {
        setLinks((prevLinks) => prevLinks.map((element) => element?.url === link?.url ? { ...element, loading: true } : element))
        updatedWebsites = websites.filter((element) => element?.url !== link?.url)
        setWebsites((prevWebsites) => prevWebsites.filter((element) => element?.url !== link?.url))

      } else {
        setLinks((prevLinks) => prevLinks.map((element) => element?.url === link?.url ? { ...element, loading: true } : element))
        updatedWebsites = [...websites, { url: link?.url, id: websites?.length, loading: true, metrics: null }]
        setWebsites((prevWebsites) => [...prevWebsites, { url: link?.url, id: prevWebsites?.length, loading: true, metrics: null }])
      }

      let result = await updateGoogleAnalyticsPropertyDetails(selectedProperty, updatedWebsites)
      if (result?.success) {
        // handlePropertySelect(selectedProperty)
        toast.success(link?.is_mapped ? "Link untracked successfully" : "Link tracked successfully")

      }

      setLinks((prevLinks) => prevLinks.map((element) => element?.url === link?.url ? { ...element, is_mapped: link?.is_mapped ? false : true, loading: false } : element))



    }
    catch (e) {
      console.log(e)
    }
    finally {

    }
  }


  useEffect(() => {
    fetchGoogleAnalyticsPropertylist()
  }, []);

  useEffect(() => {
    if (selectedProperty != null) {
      fetchLinksUnderProperty()
    }

  }, [selectedProperty]);



  return (
    <div className="w-full">
      <div className="d-flex flex-column">
        <div className="row">
          <div className="col-12">
            <div className="d-flex" style={{ minHeight: '80vh', maxHeight: '80vh' }}>

              {/* Column 1: Social Media Platforms */}
              {/* <div className={`col-md-${properties?.length>0 || loading?.domains? '2':'12'} col-12 pe-3  ${(properties?.length>0 || loading?.domains)&& 'border_end'}  overflow-y-auto position-relative`}>
              {loading?.platforms ? (
                <div className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle" style={{ minHeight: '100%' }}>
                  <LoadingSpinner />
                </div>
              ) : (
                <div>
                  <h5>Platforms</h5>
                  <ul className="p-0 mt-5 border_top">
                
                      <li
                   
                        className={`border_bottom p-3  text_primary bg_primary_light `}
                        onClick={() => handlePlatformSelect(platform)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="w-100 d-flex align-items-center gap-2 flex-start">
                          <img src={getPlatformImg(platform.platform_id)} className="img-fluid social_media_img" alt="" />
                          <span className="small">{getPlatformName(platform.platform_id)}</span>
                        </div>
                      </li>
                    
                  </ul>
                </div>
              )}
            </div> */}

              {/* Column 2: Property List */}
              {(properties && properties?.length > 0 || loading?.domains) &&
                <div className={`col-md-${selectedProperty ? '6' : '12'} col-12 px-3 ${selectedProperty && 'border_end'}  overflow-y-auto position-relative`}>
                  {loading?.domains ? (
                    <div className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle" style={{ minHeight: '100%' }}>
                      <LoadingSpinner />
                    </div>
                  ) : (
                    <div>
                      <h5>List Of Domains</h5>


                      <ul className="p-0 mt-4 border_top">
                        {properties?.map((property) => {
                          return <li className={`border_bottom p-3 ${property?.property_id === selectedProperty?.property_id && 'text_primary bg_primary_light'}   `}
                            onClick={() => handlePropertySelect(property)}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="w-100 d-flex align-items-center gap-2 flex-start ">

                              <span className="small">{property?.display_name}</span>
                            </div>
                          </li>
                        })}



                      </ul>
                    </div>
                  )}
                </div>}
              {/* column 2:list of links under property */}
              {selectedProperty != null &&
                <div className="col-md-6 col-12 px-3 border-end   position-relative ">

                  <div >
                    <h5>List Of Links</h5>
                    <span className="text_md text_color_secondary aeonik-regular">These links are being monitored for analytics data</span>
                    <div className="mt-3">
                      <input type="text" value={inputSearch} onChange={(e) => handleInputSearchChange(e?.target?.value)} className="form-control" placeholder="Search..." />
                    </div>
                  </div>
                  {linksLoading ? (
                    <div className="position-relative" style={{ minHeight: '68vh', maxHeight: '68vh' }} >
                      <div className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle" >
                        <LoadingSpinner />
                      </div>
                    </div>
                  ) : (
                    <div className="my-2 overflow-y-auto p-3 d-flex flex-column gap-3" style={{ maxHeight: '68vh', minHeight: '68vh' }} >
                      {links?.map((link) => {
                        return <div className="d-flex justify-content-between border px-3 py-3 align-items-center">
                          <div className="">
                            <span className="medium aeonik-bold">{link?.url}</span>
                          </div>
                          <div className="">
                            {link?.is_mapped ? <button onClick={() => handleTrackLink(link)} className="btn-danger btn rounded-pill aeonik-regular"   >{link?.loading ? "Loading..." : "UnTrack Link"}</button> : <button onClick={() => handleTrackLink(link)} className="btn_primary  rounded-pill aeonik-regular" disabled={link?.loading}>{link?.loading ? "Loading..." : "Track Link"}</button>}
                            {/* <button onClick={()=>handleTrackLink(link)} className="btn_primary aeonik-regular">Track Link</button> */}
                          </div>

                        </div>
                      })}
                      {links?.length === 0 && !linksLoading &&
                        <div className="text-center d-flex justify-content-center align-items-center" style={{ height: '100%' }}  >
                          <h5>No Links found</h5>
                        </div>
                      }
                    </div>
                  )}


                  {(linksPageData?.total_links > links?.length || (linksPageData?.total_links - 10) > linksPageData?.offset) &&
                    <div className="d-flex position-relative align-items-center ">
                      <button className="btn_primary aeonik-regular position-absolute top-50 start-0" onClick={() => {

                        fetchLinksUnderProperty("next")
                      }

                      }> {linksLoading ? "Loading..." : "Next Page"}</button>
                    </div>
                  }



                </div>}



              {/* Column 3: website List */}
              {(websites && websites?.length > 0 || loading?.links) &&
                <div className={`col-md-6 col-12 px-3 border-end  overflow-y-auto position-relative d-none`}>
                  {loading?.links ? (
                    <div className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle" style={{ minHeight: '100%' }}>
                      <LoadingSpinner />
                    </div>
                  ) : (
                    <div>
                      <div className="mb-3">
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="mb-0">List  Of  Links</h5>
                          <button className="btn_primary aeonik-regular" onClick={() => handleUpdateGoogleAnalyticsProperty()}> {btnLoading ? "Saving..." : "Save"}</button>
                        </div>
                        <span className="text_md text_color_secondary aeonik-regular">These links are being monitored for analytics data</span>
                      </div>

                      <ul className="p-0 mt-2 border_top">
                        {websites?.map((website, index) => {

                          return <li key={index} className={` p-1  'text_primary bg_primary_light'   `}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="w-100 d-flex align-items-center gap-2 flex-start justify-content-between">

                              {/* <span className="small">{website}</span> */}
                              <input type="text" value={website?.url} onChange={(e) => {
                                handleInputChange(e?.target?.value, website)

                              }} className="form-control" placeholder="Enter full URL (e.g., https://domain.com/path)" />

                            </div>

                          </li>
                        })}



                      </ul>
                    </div>
                  )}
                </div>}







            </div>
          </div>
        </div>


      </div>

    </div>
  );
};

export default GoogleAnalytics;
